class Mandala {
  static withTitle(title) {
    if (title == null) {
      return null
    }

    const mandala = new this()
    mandala.title = title

    const root             = `mandala/${title}`
    mandala.cellImageUrl   = `${root}/${title}/Representing/Representing.png`
    mandala.imageUrl       = `${root}/${title}.png`
    mandala.descriptionUrl = `${root}/description.txt`
    mandala.downloadUrl    = `${root}/${title}.mandala`
    return mandala
  }
}

export default Mandala



/** WEBPACK FOOTER **
 ** ./src/model/Mandala.js
 **/